import { apiSlice } from "./apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["LearnSessions"],
});

const learnApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getLearnSessionByQuizId: builder.query({
      query: (quizId) => `/learn/by-quiz/${quizId}`,
      providesTags: ["LearnSessions"],
    }),
    getLearnSession: builder.query({
      query: (id) => `/learn/${id}`,
      providesTags: ["LearnSessions"],
    }),
    getLearnHistory: builder.query({
      query: ({ page = 1, per_page = 10 } = {}) =>
        `/learn/history?page=${page}&per_page=${per_page}`,
      providesTags: ["LearnSessions"],
    }),
    generateLearnQuiz: builder.mutation({
      query: (id) => ({
        url: `/learn/${id}/generate-quiz`,
        method: "POST",
      }),
      invalidatesTags: ["LearnSessions"],
    }),
    deepenLearnSession: builder.mutation({
      query: (id) => ({
        url: `/learn/${id}/deepen`,
        method: "POST",
      }),
      invalidatesTags: ["LearnSessions"],
    }),
  }),
});

export const {
  useGetLearnSessionByQuizIdQuery,
  useGetLearnSessionQuery,
  useGetLearnHistoryQuery,
  useGenerateLearnQuizMutation,
  useDeepenLearnSessionMutation,
} = learnApiSlice;
